var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcModelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_966_27028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_966_27028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7393 1.7453C10.8993 1.64749 11.1007 1.64749 11.2607 1.7453L19.2607 6.63419C19.4094 6.72502 19.5 6.88665 19.5 7.06083V14.9392C19.5 15.1133 19.4094 15.275 19.2607 15.3658L11.2607 20.2547C11.1007 20.3525 10.8993 20.3525 10.7393 20.2547L2.73928 15.3658C2.59065 15.275 2.5 15.1133 2.5 14.9392V7.06083C2.5 6.88665 2.59065 6.72502 2.73927 6.63419L10.7393 1.7453Z",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20L11 12",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12L19 7",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7L11 12",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModelOutline);
export default __webpack_public_path__ + "static/media/ic_model_outline.3a0ec5055e7739abaa576beb6eeb9d67.svg";
export { ForwardRef as ReactComponent };